import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { ISideNavigationItem } from "interfaces/sideNavigationItem";
import { withVar } from "themes/helpers";

import { AutomationType, AutomationsRoutes } from "./constants";

export const automationsNavigationItems: (showMacroBadge: boolean) => ISideNavigationItem[] = showMacroBadge => [
  {
    id: AutomationType.Rule,
    name: "Rules",
    path: AutomationsRoutes.Rules,
  },
  {
    id: AutomationType.Macro,
    name: "Macros",
    path: AutomationsRoutes.Macros,

    customBadge: showMacroBadge ? <NewBadge>NEW!</NewBadge> : null,
  },
];

const NewBadge = styled.div`
  color: ${withVar(DesignToken.ActionNegativeDefault)};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-left: 14px;
`;
